import { eElementType, eGender } from "app/services/kryptomons/kryptomons.interface"

export interface IinfoIconSettings {
    type: eInfoIconType
    id?: eElementType | eGender // ||||
    label?: string
    currencyType?: eCurrencies,
    labelClass?: string
}

export enum eInfoIconType {
    element = 'element',
    breeding = 'breeding',
    gender = 'gender',
    text = 'text',
    currency = 'currency',
    syntetic = 'syntetic'
}

export const elementPicPath: { [key in eElementType]: string } =
{
    [eElementType.Fire]: 'assets/img/icons/fire.svg',
    [eElementType.Air]: 'assets/img/icons/air.svg',
    [eElementType.Grass]: 'assets/img/icons/grass.svg',
    [eElementType.Ice]: 'assets/img/icons/ice.svg',
    [eElementType.Electro]: 'assets/img/icons/electro.svg',
    [eElementType.Ghost]: 'assets/img/icons/ghost.svg',
    [eElementType.Ground]: 'assets/img/icons/ground.svg',
    [eElementType.Water]: 'assets/img/icons/water.svg',
}

export const breedingPicPath: string = 'assets/img/Icon/Heart.svg'

export const genderPicPath: { [key in eGender]: string } = {
    [eGender.male]: 'assets/img/Icon/male-icon.svg',
    [eGender.female]: 'assets/img/Icon/female-icon.svg'
}

export enum eCurrencies {
    KMON = 'KMON',
    CANDIES = 'CANDIES',
    BabyDoge = 'BabyDoge',
    BNB = 'BNB',
    POINTS = 'POINTS',
    USDT = 'USDT',
    CreditCard = "CreditCard"
}

export const currencyImgPath = (): { [key in eCurrencies]: string } => {
    return {
        [eCurrencies.KMON]: './assets/img/Icon/Cur-Kmon.png',
        [eCurrencies.CANDIES]: './assets/img/Icon/cur-candy-clean.svg',
        [eCurrencies.BabyDoge]: '/assets/img/Icon/cur-baby-doge.svg',
        [eCurrencies.BNB]: './assets/img/Icon/matic-logo.png',
        [eCurrencies.POINTS]: './assets/img/Icon/medal.png',
        [eCurrencies.USDT]: '/assets/img/Icon/Cur-USDT.png',
        [eCurrencies.CreditCard]: '/assets/img/Icon/credit-card.png'
    }
}